// Hypothetical calculator presets. These are not market quotes or eligibility rules.
// Keep full product descriptions in the build/fallback data, outside the calculator bundle.
export const products = {
  "merchant-cash-advance": {
    "name": "Merchant cash advance",
    "short": "MCA",
    "slug": "merchant-cash-advance",
    "amount": [
      5000,
      500000
    ],
    "costLow": 1.15,
    "costHigh": 1.49,
    "costType": "factor"
  },
  "term-loan": {
    "name": "Business term loan",
    "short": "Term loan",
    "slug": "term-loan",
    "amount": [
      10000,
      500000
    ],
    "costLow": 8,
    "costHigh": 45,
    "costType": "apr"
  },
  "line-of-credit": {
    "name": "Business line of credit",
    "short": "Line of credit",
    "slug": "line-of-credit",
    "amount": [
      10000,
      250000
    ],
    "costLow": 10,
    "costHigh": 60,
    "costType": "apr"
  },
  "sba-loan": {
    "name": "SBA loan",
    "short": "SBA loan",
    "slug": "sba-loan",
    "amount": [
      50000,
      5000000
    ],
    "costLow": 10,
    "costHigh": 13,
    "costType": "apr"
  },
  "equipment-financing": {
    "name": "Equipment financing",
    "short": "Equipment financing",
    "slug": "equipment-financing",
    "amount": [
      10000,
      2000000
    ],
    "costLow": 7,
    "costHigh": 30,
    "costType": "apr"
  },
  "invoice-factoring": {
    "name": "Invoice factoring",
    "short": "Invoice factoring",
    "slug": "invoice-factoring",
    "amount": [
      10000,
      5000000
    ],
    "costLow": 1,
    "costHigh": 5,
    "costType": "fee"
  },
  "revenue-based-financing": {
    "name": "Revenue-based financing",
    "short": "Revenue-based",
    "slug": "revenue-based-financing",
    "amount": [
      25000,
      2000000
    ],
    "costLow": 1.1,
    "costHigh": 1.5,
    "costType": "factor"
  },
  "working-capital": {
    "name": "Working capital loan",
    "short": "Working capital",
    "slug": "working-capital",
    "amount": [
      5000,
      250000
    ],
    "costLow": 15,
    "costHigh": 60,
    "costType": "apr"
  }
};

// Factoring totalPayback is the customer invoice settlement, never borrower repayment.
export const defaultMonths = slug => slug === 'sba-loan' ? 120 : slug === 'equipment-financing' ? 60 : ['line-of-credit', 'working-capital'].includes(slug) ? 12 : slug === 'merchant-cash-advance' ? 9 : slug === 'revenue-based-financing' ? 12 : 36;
export const estimatePayment = (slug, amount, options = {}) => {
  const p = products[slug];
  if (!p || !Number.isFinite(amount) || amount <= 0) return null;
  const rate = options.rate ?? (p.costLow + p.costHigh) / 2;
  const months = options.months ?? defaultMonths(slug);
  if (!Number.isFinite(rate) || rate < 0 || !Number.isFinite(months) || months <= 0 || months > 300 || !Number.isInteger(months)) return null;
  if (p.costType === 'fee') {
    const days = options.days ?? 45, advancePercent = options.advancePercent ?? 80;
    if (!(Number.isInteger(days) && days > 0 && days <= 365) || !(advancePercent > 0 && advancePercent <= 100)) return null;
    const fee = amount * rate / 100 * days / 30, cashAdvance = amount * advancePercent / 100;
    return { kind: 'factoring', payment: fee, frequency: 'invoice (fee)', totalPayback: amount,
      costAmount: fee, fee, cashAdvance, reserve: amount - cashAdvance - fee, netProceeds: amount - fee,
      count: 1, days, advancePercent, rateLabel: `${rate.toFixed(1)}% per 30 days; ${days} days; ${advancePercent}% advance` };
  }
  if (p.costType === 'factor') {
    const total = amount * rate;
    if (slug === 'revenue-based-financing' && options.monthlyRevenue !== undefined) {
      const revenue = options.monthlyRevenue, share = options.revenueShare ?? 5;
      if (!(Number.isFinite(revenue) && revenue > 0) || !(share > 0 && share <= 100)) return null;
      const payment = Math.min(total, revenue * share / 100), count = Math.ceil(total / payment);
      return { kind: 'revenue', payment, frequency: 'month at stated revenue', totalPayback: total, costAmount: total - amount,
        count, lastPayment: total - payment * (count - 1), rateLabel: `${rate.toFixed(2)}x cap; ${share}% of monthly revenue` };
    }
    const daily = slug === 'merchant-cash-advance', count = daily ? Math.max(1, Math.round(months * 21)) : months;
    return { kind: daily ? 'advance' : 'average', payment: total / count, frequency: daily ? 'business day' : 'month (assumed average)',
      totalPayback: total, costAmount: total - amount, count, rateLabel: `${rate.toFixed(2)}x; assumed ${months} months${daily ? ', 21 business days/month' : '; actual payments vary with revenue'}` };
  }
  const r = rate / 100 / 12, payment = r ? amount * r / (1 - Math.pow(1 + r, -months)) : amount / months;
  return { kind: 'loan', payment, frequency: 'month', totalPayback: payment * months, costAmount: payment * months - amount,
    count: months, rateLabel: `${rate.toFixed(1)}% assumed annual interest; ${months} months; fees excluded` };
};

